module.exports = __webpack_public_path__ + "media/images/landing_page/2023/tools/png/budget_lv-11d415f65f4fa43c6295e9365a606c48.png";